import { render } from "./AccommodationExperiencesSection.vue?vue&type=template&id=4b4d2dec&scoped=true&ts=true"
import script from "./AccommodationExperiencesSection.vue?vue&type=script&lang=ts"
export * from "./AccommodationExperiencesSection.vue?vue&type=script&lang=ts"

import "./AccommodationExperiencesSection.vue?vue&type=style&index=0&id=4b4d2dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4d2dec"]])

export default __exports__